export const SalaryFrequency = {
  MONTHLY: 'Monthly',
  WEEKLY: 'Weekly',
  HOURLY: 'Hourly',
  BI_WEEKLY: 'BiWeekly',
} as const;

export type SalaryFrequencyType =
  (typeof SalaryFrequency)[keyof typeof SalaryFrequency];

export const ChangeType = {
  AMOUNT: 'amount',
  PERCENTAGE: 'percentage',
} as const;

export type ChangeTypeType = (typeof ChangeType)[keyof typeof ChangeType];

export const SalaryStatus = {
  ACTIVE: 'Active',
  UPCOMING: 'Upcoming',
  EXPIRED: 'Expired',
} as const;

export type SalaryStatusType = (typeof SalaryStatus)[keyof typeof SalaryStatus];

export const DEFAULT_CURRENCY = 'EUR';

export type SalaryChangeFormData = {
  updateAmountOnly: boolean;
  changeType: ChangeTypeType;
  value: string;
  effectiveDate?: string;
  unknownEndDate?: boolean;
  endDate?: string;
  frequency?: SalaryFrequencyType;
  currentFrequency?: SalaryFrequencyType;
  notes?: string;
  selectedSalaryId?: string;
  currentSalary: number;
  hasPermissionIssue?: boolean;
  currency?: string;
  syncDatesWithPosition?: boolean;
};

export type SalaryChangeData = {
  currentSalaryId?: string;
  isQuickUpdate: boolean;
  effectiveDate: string;
  endDate?: string;
  newValue: number;
  newFrequency?: string;
  notes?: string;
  hasPermissionIssue?: boolean;
  formData?: SalaryChangeFormData;
};

export type SalaryChangeComponentProps = {
  selectedEmployeeId?: string;
  currentSalary?: number;
  currency?: string;
  onChange: (value: SalaryChangeData | undefined) => void;
  value?: SalaryChangeData;
  positionChangeData?: {
    effectiveDate?: string;
    unknownEndDate?: boolean;
    endDate?: string;
  };
};

export const frequencyOptions = [
  { value: SalaryFrequency.MONTHLY, label: 'monthly' },
  { value: SalaryFrequency.WEEKLY, label: 'weekly' },
  { value: SalaryFrequency.HOURLY, label: 'hourly' },
  { value: SalaryFrequency.BI_WEEKLY, label: 'bi-weekly' },
];
